import React from 'react';
import { useSelector } from 'react-redux';
import { RequestStatus } from '../config/store';
import { RootState } from '../store/rootStore';

const useDashboardStatus = (): { loading: boolean; hasError: boolean; hasAccess: boolean } => {
  const userLoadingStatus = useSelector((state: RootState) => state.global.user.request.get.status);
  const accessLoadingStatus = useSelector((state: RootState) => state.accesss.userAccess.request.get.status);
  const groupLoadingStatus = useSelector((state: RootState) => state.accesss.organization.request.get.status);
  const isAllowed = useSelector((state: RootState) => state.accesss.isAllowed);
  const loading = React.useMemo(() => {
    return [userLoadingStatus, accessLoadingStatus, groupLoadingStatus].some((status) =>
      [RequestStatus.Pending, RequestStatus.Unsent].includes(status)
    );
  }, [userLoadingStatus, accessLoadingStatus, groupLoadingStatus]);

  const hasError = React.useMemo(() => {
    return [userLoadingStatus, accessLoadingStatus, groupLoadingStatus].some(
      (status) => status === RequestStatus.Failure
    );
  }, [userLoadingStatus, accessLoadingStatus, groupLoadingStatus]);

  return { loading: isAllowed && loading, hasError, hasAccess: isAllowed };
};

export default useDashboardStatus;
